import React from "react";
import "./RequiredMark.less";

const RequiredMark = (props) => {
  return <div className="required-mark-container">{props.children}</div>;
};

export default RequiredMark;
